import React from "react";
import { useResponsiveValue } from "../../hooks/breakpoints";

const Visibility = ({ display, children }) => {
  return useResponsiveValue(display) === "visible" ? children : null;
};

export { Visibility };
